export default {
    agentList: {
        title: "Danh Sách Đại Lý",
        serial: "STT",
        agentIdCol: "ID Đại Lý",
        type: "Loại Đại Lý",
        tag: "Thẻ Đại Lý",
        typeRequired: "Vui lòng chọn loại đại lý",
        // Từ điển loại đại lý (dict_group_item nhóm 51001): chỉ ba loại do hệ thống tạo
        // sẵn mới dịch được; loại do người vận hành tạo giữ nguyên văn bản đã lưu qua defaultValue
        typeDict: {
            "51001001": "Quảng bá tại cửa hàng thực tế",
            "51001002": "Quảng bá qua quảng cáo",
            "51001003": "Quảng bá thông thường",
        },
        name: "Tên Đại Lý",
        nameRequired: "Vui lòng nhập tên đại lý",
        account: "Tài Khoản Đại Lý",
        accountRequired: "Vui lòng nhập 6-18 ký tự (chữ và số)",
        accountPlaceholder: "Vui lòng nhập tài khoản đại lý",
        domain: "Tên Miền Đại Lý",
        domainPlaceholder: "Vui lòng nhập tên miền, phân cách nhiều tên miền bằng dấu phẩy",
        inviteCode: "Mã Mời",
        inviteCodeTitle: "Mã Mời Đại Lý",
        inviteCodeType: "Loại Mã Mời",
        inviteCodeCustom: "Mã Mời Tùy Chỉnh",
        inviteCodeAuto: "Tự Động Tạo",
        inviteCodeRequired: "Vui lòng nhập mã mời",
        inviteCodeRule: "Mã mời phải có 3-12 ký tự và bao gồm cả chữ cái và số",
        inviteCodePlaceholder: "Vui lòng nhập mã mời từ 3-12 ký tự (chữ và số)",
        inviteCodeExist: "Mã mời này đã tồn tại, vui lòng chọn mã khác",
        remark: "Ghi Chú",
        add: "Thêm Đại Lý",
        addSuccess: "Thêm thành công",
        edit: "Sửa Đại Lý",
        editSuccess: "Cập nhật thành công",
        delete: "Xóa",
        deleteSuccess: "Xóa thành công",
        enabled: "Kích Hoạt",
        enableSuccess: "Kích hoạt thành công",
        disabled: "Vô Hiệu Hóa",
        disableSuccess: "Vô hiệu hóa thành công",
        lastOpTime: "Thời Gian Thao Tác Cuối",
        lastOpUser: "Người Thao Tác Cuối",
        confirmDelete: "Bạn có chắc chắn muốn xóa đại lý này?",
        confirmEnable: "Bạn có chắc chắn muốn kích hoạt đại lý này?",
        confirmDisable: "Bạn có chắc chắn muốn vô hiệu hóa đại lý này?",
        search: "Tìm Kiếm",
        reset: "Đặt Lại",
        all: "Tất Cả",
        action: "Thao Tác",
        pagination: "Tổng {total} bản ghi, Trang {current} / {page}",
        domainFormatError: "Chỉ chấp nhận tên miền hợp lệ không có 'http://' hoặc 'https://'",
        accountFormatError: "Tài khoản phải có 6-18 ký tự và bao gồm cả chữ cái và số",
      disabledKyc: "Tắt KYC đăng ký",
      confirmKycDisable: "Tắt KYC đăng ký",
      optionFalse: "Thao tác không thành công",
      confirmKycEnabled: "Bật KYC đăng ký",
      enabledKyc: "Bật KYC đăng ký",
      disabledWithdrawKyc: "Tắt KYC rút tiền",
      confirmWithdrawKycDisable: "Tắt KYC rút tiền",
      confirmWithdrawKycEnabled: "Bật KYC rút tiền",
      enabledWithdrawKyc: "Bật KYC rút tiền",
      agentLevel: "Cấp Đại Lý",
      agentLevelRequired: "Vui lòng chọn cấp đại lý",
      agentLevelTop: "Đại lý cấp 1",
      agentLevelSub: "Đại lý cấp 2",
      agentLevelTip: "Cấp 1 = đại lý cấp trên; Cấp 2 = đại lý thường (bắt buộc chỉ định cấp trên)",
      parentAgent: "Đại Lý Cấp Trên",
      parentAgentRequired: "Vui lòng chọn đại lý cấp trên",
      parentAgentPlaceholder: "Vui lòng chọn đại lý cấp trên",
      parentAgentTip: "Bắt buộc khi chọn đại lý cấp 2",
      agentLevelLockedTip: "Cấp đại lý đã thiết lập không thể thay đổi",
      parentAgentLockedTip: "Đại lý cấp trên đã thiết lập không thể thay đổi",
      expandSubAgents: "Mở danh sách đại lý cấp 2",
      collapseSubAgents: "Thu gọn đại lý cấp 2",
      loginEnable: "Kích hoạt",
      confirmEnableLogin: "Xác nhận bật đăng nhập cho đại lý này?",
      confirmEnableLoginContent: "Sau khi bật, đại lý có thể đăng nhập bình thường.",
      confirmDisableLogin: "Xác nhận tắt đăng nhập cho đại lý này?",
      confirmDisableLoginContent: "Sau khi tắt, đại lý sẽ không thể đăng nhập.",
      optionTrue: "Thao tác thành công",
      loginPassword: "Mật khẩu đăng nhập",
      loginPasswordRequired: "Vui lòng nhập mật khẩu đăng nhập",
      loginPasswordPlaceholder: "≥8 ký tự, gồm chữ cái + số",
      loginPasswordRule: "Mật khẩu phải có ít nhất 8 ký tự và bao gồm cả chữ cái lẫn số",
      loginPasswordTip: "Đại lý sẽ dùng mật khẩu này khi đăng nhập lần đầu",
      loginPasswordEditTip: "Để trống nếu không đổi; nếu nhập phải ≥8 ký tự, gồm chữ và số",
      confirmPassword: "Xác nhận mật khẩu",
      confirmPasswordRequired: "Vui lòng nhập lại mật khẩu đăng nhập",
      confirmPasswordPlaceholder: "Vui lòng nhập lại mật khẩu đăng nhập",
      confirmPasswordMismatch: "Hai mật khẩu không khớp"
  },
  agentStats: {
    title: "Thống Kê Đại Lý",
    phpTab: "PHP",
    vndTab: "VND",
    agentType: "Loại Đại Lý",
    agentTypePlaceholder: "Vui lòng chọn loại đại lý",
    agentName: "Tên Đại Lý",
    agentNamePlaceholder: "Vui lòng nhập tên đại lý",
    currency: "Tiền Tệ",
    currencyPlaceholder: "Vui lòng chọn tiền tệ",
    sequence: "STT",
    loginUserCount: "Số Lượng Người Đăng Nhập",
    registerCount: "Tổng Số Thành Viên Đăng Ký",
    firstRechargeCount: "Số Lần Nạp Tiền Đầu",
    linkClickCount: "Số Lần Bấm Vào Liên Kết",
    activatedUserCount: "Số Lượng Người Kích Hoạt",
    activatedDepositUserCount: "Số Lượng Người Kích Hoạt Nạp Tiền",
    totalRechargeAmount: "Tổng Số Tiền Nạp",
    totalWithdrawalAmount: "Tổng Số Tiền Rút",
    betFlow: "Cược Hợp Lệ",
    gameAmount: "Lãi/Lỗ Nền Tảng",
    cost: "Tổng Chi Phí Kênh",
    registerCost: "Chi Phí Đăng Ký",
    firstRechargeCost: "Chi Phí Nạp Lần Đầu",
    costTooltip: "Giá trị tổng tích lũy \"chi phí\" của đại lý này",
    registerCostTooltip: "Chi phí đăng ký = Tổng chi phí kênh / Tổng số người đăng ký",
    firstRechargeCostTooltip: "Chi phí nạp lần đầu = Tổng chi phí kênh / Tổng số người nạp lần đầu",
    currRegisterCost: "Chi Phí Đăng Ký Hàng Ngày",
    currFirstRechargeCost: "Chi Phí Nạp Lần Đầu Hàng Ngày",
    currRegisterCostTooltip: "Chi phí đăng ký = Chi phí hàng ngày / Số người đăng ký hàng ngày",
    currFirstRechargeCostTooltip: "Chi phí nạp lần đầu = Chi phí hàng ngày / Số người nạp lần đầu hàng ngày",
    pleaseSearchFirst: "Vui lòng tìm kiếm trước",
    riskCount: "Số Lượng Thành Viên Nguy Hiểm",
    riskCountPercent: "Tỷ Lệ Thành Viên Nguy Hiểm",
  },
  // Báo cáo phân loại trò chơi hàng ngày (FBMPLAY-1670)
  agentGameCategoryReport: {
    gameCategory: "Phân loại trò chơi",
    gameProvider: "Nhà cung cấp trò chơi",
    memberGroup: "Dữ liệu hội viên",
    totalMemberCount: "Tổng số hội viên",
    registerCount: "Đăng ký hôm nay",
    rechargeGroup: "Nạp tiền",
    withdrawGroup: "Rút tiền",
    amountCol: "Tổng tiền",
    countCol: "Số người",
    betCount: "Số lượt cược",
    betAmount: "Cược",
    payoutAmount: "Trả thưởng",
    ggr: "GGR",
    totalGroup: "Tổng cộng",
    totalBonus: "Tổng khuyến mãi",
    totalBet: "Tổng cược",
    totalPayout: "Tổng trả thưởng",
    totalGgr: "Tổng GGR",
    officialDirect: "Khách Hàng Trực Tiếp Chính Thức",
  },
  agentDailyStats: {
    title: "Hiệu Suất Hàng Ngày Của Đại Lý",
    day: "Ngày",
    agentType: "Loại Đại Lý",
    agentName: "Tên Đại Lý",
    agentNamePlaceholder: "Vui lòng nhập tên đại lý",
    loginUserCount: "Số Lượng Người Đăng Nhập",
    registerCount: "Số Lượng Đăng Ký",
    firstRechargeCount: "Số Lần Nạp Đầu",
    firstDepositAmount: "Số Tiền Nạp Lần Đầu",
    rechargeCount: "Số Lần Nạp Tiền",
    rechargeAmount: "Số Tiền Nạp",
    linkClickCount: "Số Lần Bấm Vào Liên Kết",
    activatedUserCount: "Số Lượng Người Kích Hoạt",
    activatedDepositUserCount: "Số Lượng Người Kích Hoạt Nạp Tiền",
    withdrawalCount: "Số Lần Rút Tiền",
    withdrawalAmount: "Số Tiền Rút",
    betFlow: "Cược Hợp Lệ",
    gameAmount: "Lãi/Lỗ Nền Tảng",
    betAmount: "Số Tiền Cược",
    payoutAmount: "Số Tiền Trả Thưởng",
    ggr: "GGR",
    netAmount: "Lãi/Lỗ Nạp Rút Tiền",
    pleaseSearchFirst: "Vui lòng tìm kiếm trước"
  },
  agentCostStats: {
    title: "Chi Phí Khuyến Mại",
    day: "Ngày",
    agentType: "Loại Đại Lý",
    agentName: "Tài Khoản Đại Lý",
    agentNamePlaceholder: "Vui lòng nhập tên đại lý",
    registerCount: "Số Lượng Đăng Ký",
    rechargeCount: "Số Lần Nạp Tiền",
    rechargeAmount: "Số Tiền Nạp",
    withdrawalCount: "Số Lần Rút Tiền",
    withdrawalAmount: "Số Tiền Rút",
    profit: "Lãi/Lỗ",
    cost: "Chi Phí",
    returnRate: "Tỷ Lệ Hoàn Vốn",
    paybackDays: "Số Ngày Hoàn Vốn",
    action: "Thao Tác",
    editCost: "Chi Phí",
    editCostModalTitle: "Chỉnh Sửa Chi Phí",
    costLabel: "Số Tiền Chi Phí",
    costPlaceholder: "Vui lòng nhập số tiền chi phí",
    costRequired: "Vui lòng nhập số tiền chi phí",
    costMinValue: "Số tiền chi phí không thể nhỏ hơn 0",
    updateCostSuccess: "Cập nhật chi phí thành công",
    pleaseSearchFirst: "Vui lòng tìm kiếm trước",
    dateRangeExceeds31Days: "Khoảng thời gian không thể vượt quá 31 ngày"
  },
  agentTodayData: {
    title: "Dữ liệu đại lý hôm nay",
    levelTop: "Cấp 1",
    levelSub: "Cấp 2",
    levelSelf: "Trực tiếp",
    aggregatedSuffix: "(Tổng)",
    agentAccount: 'Tài khoản đại lý',
    search: 'Tìm kiếm',
    pleaseEnterAgentAccount: 'Vui lòng nhập tài khoản đại lý',
    agentAccountNotFound: 'Tài khoản đại lý bạn đã nhập không tồn tại, vui lòng nhập lại',
    noData: 'Không có dữ liệu, vui lòng tìm kiếm đại lý trước',
    registerCount: 'Người dùng đã đăng ký',
    firstRechargeCount: 'Người dùng nạp tiền lần đầu',
    rechargeCount: 'Người dùng nạp tiền',
    withdrawalCount: 'Người dùng rút tiền',
    profit: 'Lời/lỗ Nạp/Rút tiền',
    firstRechargeAmount: 'Số tiền nạp lần đầu',
    rechargeAmount: 'Số tiền nạp',
    withdrawalAmount: 'Số tiền rút',
    agentAccountDigitsOnly: 'Tài khoản đại lý chỉ có thể chứa các chữ số',
  },
  agentTag: {
    title: "Thẻ Đại Lý",
    serial: "STT",
    tagName: "Tên Thẻ",
    tagNameRequired: "Vui lòng nhập tên thẻ",
    tagNamePlaceholder: "Vui lòng nhập",
    remark: "Ghi Chú",
    remarkPlaceholder: "Vui lòng nhập",
    lastOpTime: "Thời Gian Thao Tác Cuối",
    lastOpUser: "Người Thao Tác Cuối",
    action: "Thao Tác",
    add: "Thêm Thẻ Đại Lý",
    addSuccess: "Thêm thành công",
    edit: "Sửa",
    editSuccess: "Cập nhật thành công",
    delete: "Xóa",
    deleteSuccess: "Xóa thành công",
    confirmDelete: "Bạn có chắc chắn muốn xóa thẻ này?",
    search: "Tìm Kiếm",
    reset: "Đặt Lại",
    pagination: "Tổng {total} bản ghi, Trang {current} / {page}",
  },
  agentTransfer: {
    tab_transfer: "Chuyển đại lý",
    tab_history: "Bản ghi chuyển",
    tab_game_category: "Báo cáo phân loại trò chơi hàng ngày",
    sidebar_search_placeholder: "Tìm tài khoản đại lý",
    sidebar_empty: "Không có đại lý",
    sidebar_tag_l1: "Cấp 1",
    sidebar_tag_l2: "Cấp 2",
    sidebar_subagent_count_tooltip: "Có {count} đại lý cấp 2",
    sidebar_loading: "Đang tải…",
    sidebar_no_subagents: "Không có đại lý cấp 2",
    empty_select_l1: "Vui lòng chọn đại lý cấp 1 ở bên trái",
    empty_select_l2: "Vui lòng chọn đại lý cấp 2 ở bên trái",
    tag_top_agent: "Đại lý cấp 1",
    tag_sub_agent: "Đại lý cấp 2",
    stat_sub_count: "Số đại lý cấp 2",
    stat_direct_member: "Hội viên trực thuộc",
    btn_demote_to_l2: "Hạ cấp xuống cấp 2",
    card_subagent_list: "Đại lý cấp 2 trực thuộc",
    col_agent_account: "Tài khoản đại lý",
    col_agent_name: "Tên đại lý",
    col_action: "Thao tác",
    btn_transfer: "Chuyển",
    empty_no_subagent_for_l1: "Đại lý cấp 1 này chưa có đại lý cấp 2",
    member_count_unit_suffix: "",
    card_direct_member: "Hội viên trực thuộc",
    card_recent_log: "Bản ghi chuyển gần đây",
    btn_view_all_log: "Xem toàn bộ bản ghi",
    no_recent_log: "Không có bản ghi",
    log_upgrade_text: "{account} đã nâng cấp từ cấp 2 lên cấp 1",
    log_demote_text: "{account} đã hạ cấp từ cấp 1 xuống cấp 2, gắn vào {target}",
    log_transfer_text: "{account} đã chuyển từ {from} → {to}",
    demote_blocked_title: "Không thể hạ cấp trực tiếp",
    demote_blocked_line1: "Đại lý cấp 1 này còn {count} đại lý cấp 2, không thể hạ cấp trực tiếp.",
    demote_blocked_line2: "Vui lòng chuyển đại lý cấp 2 sang đại lý cấp 1 khác trước, rồi mới thực hiện hạ cấp.",
    sub_panel_parent_l1: "Cấp 1 trực thuộc: ",
    sub_panel_member_count: "Hội viên trực thuộc",
    btn_transfer_to_other_l1: "Chuyển sang cấp 1 khác",
    btn_upgrade_to_l1: "Nâng cấp lên cấp 1",
    member_card_title_default: "Hội viên trực thuộc",
    member_col_account: "Tài khoản hội viên",
    member_col_vip: "Cấp VIP",
    member_col_deposit: "Tổng nạp",
    member_col_last_login: "Đăng nhập cuối",
    member_col_status: "Trạng thái",
    member_status_active: "Hoạt động",
    member_status_inactive: "Không hoạt động",
    member_empty: "Đại lý này chưa có hội viên",
    member_total: "Tổng {total} bản ghi",
    member_load_fail: "Tải danh sách hội viên thất bại",
    transfer_modal_title: "Chuyển đại lý cấp 2",
    transfer_modal_ok: "Xác nhận chuyển",
    modal_cancel: "Hủy",
    modal_label_account: "Tài khoản đại lý: ",
    modal_label_name: "Tên đại lý: ",
    modal_label_current_parent: "Cấp 1 hiện tại: ",
    modal_label_member_count: "Hội viên trực thuộc: ",
    transfer_info_member_count: "Hội viên trực thuộc",
    transfer_info_follow: "Tất cả sẽ theo cùng chuyển sang đại lý cấp 1 mục tiêu",
    transfer_field_target: "Đại lý cấp 1 mục tiêu",
    transfer_field_target_required: "Vui lòng chọn đại lý cấp 1 mục tiêu",
    transfer_field_target_placeholder: "Vui lòng chọn đại lý cấp 1 mục tiêu",
    transfer_field_reason: "Lý do chuyển",
    transfer_field_reason_required: "Vui lòng nhập lý do chuyển",
    transfer_field_reason_placeholder: "Vui lòng nhập lý do chuyển",
    transfer_impact_title: "Ảnh hưởng sau khi chuyển:",
    transfer_impact_1: "1. Đại lý cấp 2 này được gắn vào cấp 1 mục tiêu, hội viên trực thuộc vẫn thuộc về đại lý cấp 2 này.",
    transfer_impact_2_a: "2. Đại lý trực thuộc của hội viên không đổi, chỉ thay đổi cấp 1 phía trên từ \"",
    transfer_impact_2_b: "\" thành cấp 1 mục tiêu.",
    transfer_impact_3: "3. Bản ghi cược / nạp / rút lịch sử giữ nguyên thuộc tính gốc, không cập nhật ngược.",
    transfer_impact_4: "4. Dữ liệu mới sau khi chuyển sẽ thống kê theo thuộc tính mới.",
    transfer_impact_5: "5. Dữ liệu tổng hợp lên cấp trên (đăng ký, nạp, rút, cược hợp lệ, lãi lỗ) của cấp 1 cũ và cấp 1 mục tiêu sẽ được tính lại.",
    transfer_alert: "Toàn bộ hội viên trực thuộc sẽ theo cùng chuyển · Không phát sinh hội viên trùng/không thuộc về · Thao tác không thể hoàn tác",
    upgrade_modal_title: "Nâng cấp lên đại lý cấp 1",
    upgrade_modal_ok: "Xác nhận nâng cấp",
    upgrade_current: "Hiện tại: ",
    upgrade_info_follow: "Tất cả sẽ theo cùng thành trực thuộc cấp 1 mới",
    upgrade_impact_title: "Ảnh hưởng sau khi nâng cấp:",
    upgrade_impact_1: "1. Đại lý này thay đổi từ cấp 2 thành cấp 1, tách khỏi quản lý của cấp 1 cũ và trở thành cấp 1 độc lập.",
    upgrade_impact_2_bold: "Toàn bộ hội viên trực thuộc → theo cùng",
    upgrade_impact_2_post: ", từ \"hội viên cấp 2 trực thuộc\" thành \"hội viên cấp 1 mới trực thuộc\".",
    upgrade_impact_3: "3. Đại lý trực thuộc của hội viên không đổi (vẫn là cùng một đại lý), chỉ là cấp của đại lý được nâng lên.",
    upgrade_impact_4: "4. Mã mời giữ nguyên, thêm đặc quyền: có thể cấu hình tên miền đại lý.",
    upgrade_impact_5: "5. Dữ liệu tổng hợp lên cấp trên (đăng ký, nạp, rút, cược hợp lệ, lãi lỗ) của cấp 1 cũ sẽ được tính lại toàn bộ.",
    upgrade_impact_note: "Sẽ không xảy ra xung đột: đại lý trực thuộc của hội viên không thay đổi, chỉ là cấp đại lý được nâng lên.",
    upgrade_field_reason: "Lý do nâng cấp",
    upgrade_field_reason_required: "Vui lòng nhập lý do nâng cấp",
    upgrade_field_reason_placeholder: "Ví dụ: mở rộng kinh doanh, vận hành độc lập, v.v.",
    upgrade_success_alert_prefix: "✅ Sau khi nâng cấp trở thành đại lý cấp 1 độc lập · Toàn bộ hội viên trực thuộc theo cùng · Mã mời giữ nguyên · Thêm cấu hình tên miền đại lý · ",
    upgrade_success_alert_bold: "Thao tác không thể hoàn tác",
    demote_modal_title: "Hạ cấp xuống đại lý cấp 2",
    demote_modal_ok: "Xác nhận hạ cấp",
    demote_label_current: "Đại lý hiện tại: ",
    demote_label_current_tier: "Cấp hiện tại: ",
    demote_label_after_tier: "Sau khi hạ cấp: ",
    demote_field_new_parent: "Đại lý cấp 1 mới",
    demote_field_new_parent_required: "Vui lòng chọn đại lý cấp 1 mới",
    demote_field_new_parent_placeholder: "Chọn đại lý cấp 1 nào để gắn vào sau khi hạ cấp",
    demote_field_reason: "Lý do hạ cấp",
    demote_field_reason_required: "Vui lòng nhập lý do hạ cấp",
    demote_field_reason_placeholder: "Vui lòng nhập lý do hạ cấp",
    demote_impact_title: "Ảnh hưởng sau khi hạ cấp:",
    demote_impact_1: "1. Cấp của đại lý này thay đổi từ \"cấp 1\" thành \"cấp 2\", gắn vào đại lý cấp 1 mục tiêu.",
    demote_impact_2: "2. Hội viên trực thuộc vốn có của đại lý này giữ nguyên (tự động theo cùng).",
    demote_impact_3: "3. Mã mời và tên miền đại lý giữ nguyên, hội viên mới vẫn có thể đăng ký vào đại lý này qua kênh cũ.",
    demote_impact_4: "4. Bản ghi cược / nạp / rút lịch sử giữ nguyên thuộc tính gốc, không cập nhật ngược.",
    demote_alert: "Thao tác không thể hoàn tác · Sau khi hạ cấp, đại lý sẽ không thể nhận đại lý cấp 2 mới với tư cách cấp 1 · Nếu muốn khôi phục, vui lòng liên hệ quản trị viên",
    msg_load_agent_list_fail: "Tải danh sách đại lý thất bại",
    msg_load_subagent_fail: "Tải danh sách đại lý cấp 2 thất bại",
    msg_transfer_success: "{account} đã chuyển sang {target}",
    msg_transfer_fail: "Chuyển thất bại",
    msg_upgrade_success: "{account} đã được nâng cấp thành đại lý cấp 1",
    msg_upgrade_fail: "Nâng cấp thất bại",
    msg_demote_success: "{account} đã bị hạ cấp, gắn vào {target}",
    msg_demote_fail: "Hạ cấp thất bại",
  },
  transferLog: {
    related_top_agent: "Đại lý cấp 1 liên quan",
    related_top_agent_hint: "(Chỉ hiển thị các bản ghi chuyển / hạ cấp / nâng cấp liên quan đến đại lý cấp 1 này)",
    filter_transfer_type: "Loại thao tác",
    filter_transfer_type_placeholder: "Tất cả",
    filter_agent_account: "Tài khoản đại lý",
    filter_agent_account_placeholder: "Đại lý bị thao tác",
    filter_from_parent: "Cấp 1 cũ",
    filter_from_parent_placeholder: "Tài khoản cấp 1 cũ",
    filter_to_parent: "Cấp 1 mới",
    filter_to_parent_placeholder: "Tài khoản cấp 1 mới",
    filter_date_range: "Thời gian thao tác",
    search: "Tìm Kiếm",
    reset: "Đặt Lại",
    query_fail: "Tìm kiếm thất bại",
    type_transfer: "Chuyển",
    type_demote: "Hạ cấp",
    type_upgrade: "Nâng cấp",
    col_record_id: "Mã bản ghi",
    col_transfer_type: "Loại thao tác",
    col_agent_account: "Tài khoản đại lý",
    col_from: "Thuộc về cũ",
    col_to: "Thuộc về mới",
    col_reason: "Lý do",
    col_operator: "Người thao tác",
    col_create_time: "Thời gian thao tác",
    tier_l1: "Cấp 1",
    tier_l2: "Cấp 2",
    total: "Tổng {total} bản ghi",
  },
  agentType: {
    title: "Loại Đại Lý",
    serial: "STT",
    typeName: "Tên Loại",
    typeNameRequired: "Vui lòng nhập tên loại",
    typeNamePlaceholder: "Vui lòng nhập",
    typeDesc: "Mô Tả Loại",
    typeDescRequired: "Vui lòng nhập mô tả loại",
    typeDescPlaceholder: "Vui lòng nhập",
    lastOpTime: "Thời Gian Thao Tác Cuối",
    lastOpUser: "Người Thao Tác Cuối",
    action: "Thao Tác",
    add: "Thêm",
    addSuccess: "Thêm thành công",
    edit: "Sửa",
    editSuccess: "Cập nhật thành công",
    delete: "Xóa",
    deleteSuccess: "Xóa thành công",
    confirmDelete: "Bạn có chắc chắn muốn xóa loại này?",
    search: "Tìm Kiếm",
    reset: "Đặt Lại",
    pagination: "Tổng {total} bản ghi, Trang {current} / {page}",
  }
};
